import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import { ConfirmationModal } from '../components/ConfirmationModal';
import { useRouter } from 'next/router';
import React, { createContext, useEffect, useRef, useState } from 'react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DEFAULT_STATE = {
  shouldWarn: false,
  setShouldWarn: null
};
var ModalContext = /*#__PURE__*/createContext(DEFAULT_STATE);

var ModalProvider = function ModalProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      showModal = _useState[0],
      toggleModal = _useState[1];

  var _useState2 = useState(DEFAULT_STATE.shouldWarn),
      shouldWarn = _useState2[0],
      setShouldWarn = _useState2[1];

  var resolver = useRef(null);
  var router = useRouter();
  useEffect(function () {
    var routeChangeStart = function routeChangeStart(url) {
      toggleModal(true);
      var openModal = handleShow();
      Promise.allSettled([openModal]).then(function (res) {
        res.forEach(function (result) {
          if (router.asPath !== url) {
            if (result.status === 'fulfilled' && result.value) {
              toggleModal(false);
              router.push(url);
            } else {
              try {
                toggleModal(false);
                setShouldWarn(true);
                router.events.emit('routeChangeError');
                router.replace(router.asPath, router.asPath, {
                  shallow: true
                }); // Cancel routeChange event by erroring
                // See https://github.com/zeit/next.js/issues/2476
                // eslint-disable-next-line no-throw-literal

                throw "Route change to \"".concat(url, "\" was aborted (this error can be safely ignored).");
              } catch (error) {
                // eslint-disable-next-line no-console
                console.log(error, 'route change aborted');
              }
            }
          }
        });
      }); // Cancel routeChange event by erroring
      // See https://github.com/zeit/next.js/issues/2476
      // eslint-disable-next-line no-throw-literal

      throw "waiting for Route change";
    };

    if (shouldWarn && !showModal) {
      router.events.on('routeChangeStart', routeChangeStart);
    }

    return function () {
      router.events.off('routeChangeStart', routeChangeStart);
    };
  }, [shouldWarn]);

  var handleShow = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve) {
                resolver.current = resolve;
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleShow() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleConfirm = function handleConfirm(response) {
    setShouldWarn(false);
    resolver.current(response);
  };

  return /*#__PURE__*/_jsxs(ModalContext.Provider, {
    value: {
      shouldWarn: shouldWarn,
      setShouldWarn: setShouldWarn
    },
    children: [/*#__PURE__*/_jsx(_Fragment, {
      children: children
    }), /*#__PURE__*/_jsx(ConfirmationModal, {
      heading: "Are you sure?",
      body: "If you navigate away from this page you will lose the changes you have made.",
      cancelText: "Nevermind",
      confirmText: "Yes, Leave Page",
      onConfirm: function onConfirm() {
        return handleConfirm(true);
      },
      showModal: showModal,
      setModal: function setModal() {
        return handleConfirm(false);
      }
    })]
  });
};

var ModalConsumer = ModalContext.Consumer;
export { ModalContext, ModalProvider, ModalConsumer };